import axios from "axios";

export const getEventTypes = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/eventtypes/" + encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const addEventType = (eventType) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/eventtypes/addEventType",
      eventType
    )
    .then((res) => res.data);
};

export const deleteEventType = (eventTypeId) => {
  return axios
    .delete(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/eventtypes/deleteeventtype/" +
        encodeURIComponent(eventTypeId)
    )
    .then((res) => res.data);
};

export const editEventType = (eventType) => {
  return axios
    .put(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/eventtypes/editeventtype",
      eventType
    )
    .then((res) => res.data);
};
